import React, {Component} from 'react'
import { Redirect } from 'react-router-dom'
import * as config from '../Configuration/Config.js'
import UserProfile from '../Configuration/UserProfile'

class AdminCustomerProfile extends Component {
    constructor() {
        super();

        this.handleChange = this.handleChange.bind(this)
        this.handleSave = this.handleSave.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.handleCancel = this.handleCancel.bind(this)
        this.handleUpdateViz = this.handleUpdateViz.bind(this)

        this.state = {
            is_loaded: false,
            redirect_customers: false,
            id: null,
            customer: null,
            menus: null
        }
    }

    setRedirect() {
        this.setState({redirect_customers: true});
    }

    componentDidMount() {

        const id = this.props.id;
        if (!id) {
            this.setState({ is_loaded: true, id: null, customer: null });
            return;
        }

        if (id === "new") {
            const data = {
                customer_id: '',
                customer_name: '',
                customer_phone: '',
                customer_group_id: '',
                customer_address: '',
                customer_address_city: '',
                customer_address_state: '',
                customer_address_postal_code: '',
                customer_custom_workspace_id: ''
            };

            //this.setState({ is_loaded: true, id: id, customer: data });
            this.fetchUserMenu(id,data);
            return;
        }

        var that = this;
        const uri = config.getUriPath('customers/' + id)
        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
            if (response.status >= 400) {
              throw new Error("Bad response from server");
            }
            return response.json();
          })
          .then(function(data) {
            //that.setState({ is_loaded: true, id: id, customer: data });
            that.fetchUserMenu(id,data);
          });

            
    }

    fetchUserMenu(id, customer)
    {
        var that = this;
        const uri = config.getUriPath('customers/views/' + id)
        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
            }).then(function(response) {
                if (response.status >= 400) {
                throw new Error("Bad response from server");
                }
                return response.json();
        })
        .then(function(data) {                                           
                that.setState({ is_loaded: true, id: id, customer: customer, menus:data });
        });
      
    }

    handleSave(event) {
        event.preventDefault();

        var that = this;
        const id = this.props.id;
        let uriId = '';
        let method = 'post';
        if (id !== "new") {
            uriId = '/' + id;
            method = 'put';
        }

        const uri = config.getUriPath('customers' + uriId);
        const h = config.ApiHeaders();
        // console.log(uri);
        // console.log(h);
        // console.log(this.state.customer);
        fetch(uri, {
            method: method,
            headers: h,
            body: JSON.stringify(this.state.customer)
        }).then(function(response) {
            if (response.status >= 400) {
              console.log(response);
              throw new Error("Bad response from server");
            }

            that.setRedirect();        
        });
    }

    handleUpdateViz(event) {
        event.preventDefault();

        const b = {
            customer_id: this.props.id
        }
        fetch(config.getUriPath('customers/views/update'), {
            method: 'post',
            headers: config.ApiHeaders(),
            body: JSON.stringify(b)
        }).then(function(response) {
            if (response.status >= 400) {
              console.log(response);
              throw new Error("Bad response from server");
            }

            alert('Visualization List Updated');
        });
    }

    handleDelete(event) {
        event.preventDefault();

        const canDel = window.confirm('Are you sure you want to delete this customer?');
        
        if (canDel === false) {
            return;
        }

        var that = this;

        const uri = config.getUriPath('customers/' + this.props.id)
        fetch(uri, {
            method: 'delete',
            headers: config.ApiHeaders()
        }).then(function(response) {
            if (response.status >= 400) {
              throw new Error("Bad response from server");
            }

            that.setRedirect();        
        });
    }

    handleCancel(event) {
        event.preventDefault();

        this.setRedirect();        
    }

    handleChange(event) {
        let data = this.state.customer;
        data[event.target.name] = event.target.value;
        this.setState({customer: data});
    }

    render() {
        if (this.state.is_loaded === false) {
            return <div></div>
        }

        if (this.state.redirect_customers){
            return <Redirect to='/admin/customers' />
        }

        const {id, customer} = this.state;

        if (!id || !customer) {
            return <h1>No customer selected</h1>
        }

        const isNew = this.state.id === "new";
        const profile = new UserProfile();
        const isAcumenAdmin = profile.IsAcumenAdmin();
        const title = (id === "new") ? "Create New Customer" : "Edit Profile: " + customer.customer_name
        return  <div>
                    <div className="center-div">
                        <h1>{title}</h1>
                    </div>
                    <br />
                    <div className="form-wrapper">
                    <form>
                    <div className="form-group">
                            <label htmlFor="customer_name">Customer Name:</label>
                            <input type="text" onChange={this.handleChange} className="form-control" name="customer_name" defaultValue={customer.customer_name}/>
                        </div>
                        <div className="form-group">
                            <label htmlFor="customer_abbreviation">Customer Abbreviation:</label>
                            <input type="text" onChange={this.handleChange} className="form-control" name="customer_abbreviation" defaultValue={customer.customer_abbreviation}/>
                        </div>
                        <div className="form-group">
                            <label htmlFor="customer_group_id">Group Id:</label>
                            <div><input type="text" onChange={this.handleChange} className="form-control" name="customer_group_id" defaultValue={customer.customer_group_id} /></div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="customer_group_friendly_name">Group Friendly Name:</label>
                            <div><input type="text" onChange={this.handleChange} className="form-control" readOnly="readonly" name="customer_group_friendly_name" defaultValue={customer.customer_group_friendly_name} /></div>
                        </div>
                        
                       
                        <div className="form-group">   
                            <label htmlFor="customer_default_link">Default Page:</label>
                            <div>
                                <select name="customer_default_link" className="form-control" onChange={this.handleChange} defaultValue={customer.customer_default_link}>
                                {this.state.menus.map((item) => {
                                    return (<option value={item.url}>{item.title}</option>)
                                })}
                                </select>
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="customer_phone">Phone Number:</label>
                            <div><input type="text" onChange={this.handleChange} className="form-control" name="customer_phone" defaultValue={customer.customer_phone} /></div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="customer_address">Street Address:</label>
                            <div><input type="text" onChange={this.handleChange} className="form-control" name="customer_address" defaultValue={customer.customer_address} /></div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="customer_address_city">City:</label>
                            <div><input type="text" onChange={this.handleChange} className="form-control" name="customer_address_city" defaultValue={customer.customer_address_city} /></div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="customer_address_state">State:</label>
                            <div><input type="text" onChange={this.handleChange} className="form-control" name="customer_address_state" defaultValue={customer.customer_address_state} /></div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="customer_address_postal_code">Postal Code:</label>
                            <div><input type="text" onChange={this.handleChange} className="form-control" name="customer_address_postal_code" defaultValue={customer.customer_address_postal_code} /></div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="customer_custom_workspace_id">myAcumen:</label>
                            <div><input type="text" onChange={this.handleChange} className="form-control" name="customer_custom_workspace_id" defaultValue={customer.customer_custom_workspace_id} /></div>
                        </div>        

                        <div className="form-group">
                            <div className="centerAlign" colSpan="2">
                                <button onClick={this.handleSave} name="save" className="loginButton btn btn-primary">Save</button>
                                &nbsp;&nbsp;
                                <button onClick={this.handleUpdateViz} className={(isAcumenAdmin === false || isNew) ? 'hidden' : "loginButton btn btn-primary"} name="updateviz">Update Visualizations</button>
                                &nbsp;&nbsp;
                                <button onClick={this.handleDelete} name="delete" className={isNew ? "hidden" : "loginButton btn btn-danger"}>Delete</button>
                                &nbsp;&nbsp;
                                <button onClick={this.handleCancel} name="cancel" className="loginButton btn btn-info">Cancel</button>
                            </div>
                        </div>
                    </form>
                    </div>
                </div>
    }
}

export default AdminCustomerProfile


// WEBPACK FOOTER //
// ./src/Components/AdminCustomers/AdminCustomerProfile.js